import { render, staticRenderFns } from "./ReminderDialog.vue?vue&type=template&id=763826ec&scoped=true"
import script from "./ReminderDialog.vue?vue&type=script&lang=js"
export * from "./ReminderDialog.vue?vue&type=script&lang=js"
import style0 from "./ReminderDialog.vue?vue&type=style&index=0&id=763826ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763826ec",
  null
  
)

export default component.exports